// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React, { forwardRef, useId } from 'react';
import './Radio.css';

interface RadioProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size' | 'type'> {
  label?: string;
  size?: 'md' | 'sm';
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ label, size = 'md', className = '', id: idProp, disabled, ...rest }, ref) => {
    const autoId = useId();
    const id = idProp ?? autoId;

    const classes = [
      'fin-radio',
      `fin-radio--${size}`,
      disabled && 'fin-radio--disabled',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <label className={classes} htmlFor={id}>
        <input
          ref={ref}
          id={id}
          type="radio"
          className="fin-radio__input"
          disabled={disabled}
          {...rest}
        />
        <span className="fin-radio__control" />
        {label && <span className="fin-radio__label">{label}</span>}
      </label>
    );
  },
);

Radio.displayName = 'Radio';
